<div class="row mt-5 gap-2" id="top-wrapper">
    <div class="pt-2 pb-4">
        <button class="btn btn-primary px-4" (click)="goBack()">
            <i class="fa fa-chevron-left mr-3"></i>&nbsp;{{
            "labels.back" | translate
            }}
        </button>
    </div>
    <h3 class="ml-3">{{ "labels.jobId" | translate }}: {{jobId}}, <a class="headerlink" (click)="goToTask()">{{ "customerTasksPage.taskTitle" | translate }}: {{taskTitle}}</a>, <a class="headerlink" (click)="goToCustomer()">{{ "contracts.customerName" | translate }}: {{customerName}}</a></h3>
    @if (contract) {
    <div class="col-12 mb-4">
        <ag-grid-angular
            style="width: 100%; height: 90px"
            [headerHeight]="48"
            [rowHeight]="42"
            [rowData]="contractInfoRows"
            [columnDefs]="infoColDefs"
            [defaultColDef]="infoDefaultColDef" />
    </div>
    }
    <div class="col-12">
        <div class="row">
            @if(contractByProfile.length > 0) {
            <div class="detail-section col-12 col-md-6">
                <h4 class="title">
                    <a class="headerlink" (click)="goToProfile()">{{
                        "contractsDetails.overviewOfContracts"
                        | translate : { consultant: consultantName}
                        }}</a>
                </h4>
                <div class="contract-profile">
                    <ag-grid-angular style="width: 100%; height: 100%" [rowData]="contractByProfile"
                        [columnDefs]="colDefsByProgileId" [defaultColDef]="defaultColDef" [stopEditingWhenCellsLoseFocus]="true"
                        [getRowClass]="getRowClass" (rowDoubleClicked)="onRowClicked($event)" />
                </div>
            </div>
            }
            @if(contractsByProfileAndCustomer.length > 0) {
            <div class="detail-section col-12 col-md-6">
                <h4 class="title">{{
                    "contractsDetails.overviewOfContractsWithCustomer"
                    | translate : { consultant: consultantName, customer: customerName}
                    }}</h4>
                <div class="contract-profile">
                    <ag-grid-angular style="width: 100%; height: 100%" [rowData]="contractsByProfileAndCustomer"
                        [columnDefs]="colDefs" [defaultColDef]="defaultColDef" [stopEditingWhenCellsLoseFocus]="true"
                        [getRowClass]="getRowClass" (rowDoubleClicked)="onRowClicked($event)" />
                </div>
            </div>
            }
        </div>
    </div>
    @if (contractCurrencies?.length) {
    <div class="col-12 mt-4">
        <div class="row">
            <div class="detail-section col-12 col-md-6">
                <h4 class="title">{{ "contractsDetails.altCurrencyBox.title" | translate }}</h4>
                <ag-grid-angular
                    class="ag-theme-alpine"
                    style="width: 100%; height: 150px;"
                    [rowData]="contractCurrencies"
                    [columnDefs]="currencyColDefs"
                    [defaultColDef]="currencyDefaultColDef"
                    (gridReady)="onCurrencyGridReady($event)" />
            </div>
        </div>
    </div>
    }
    <div class="tab-container col-12">
        <button [ngClass]="{'active':showTab == 'Extensions' }" class="btn btn-outline-primary tab-button"
            (click)="goToTab('Extensions')">
            {{ "extensions.title" | translate }}
        </button>
        <button [ngClass]="{'active':showTab == 'Comments' }" class="btn btn-outline-primary tab-button"
            (click)="goToTab('Comments')">
            {{ "contractComment.title" | translate }}
        </button>

    </div>

    @if(showTab === "Extensions") {
    <div class="extensions-section col-12">
        <div class="d-flex justify-content-between align-items-start mb-2 gap-2 flex-wrap">
            <div class="d-flex align-items-end gap-2 flex-wrap">
                <div class="status-filter">
                    <label class="form-label small mb-1">{{ "extensions.filterStatus" | translate }}</label>
                    <select class="form-select form-select-sm" [(ngModel)]="selectedExtensionStatus"
                        (ngModelChange)="applyExtensionStatusFilter()">
                        <option [ngValue]="null">{{ "extensions.filterAllStatuses" | translate }}</option>
                        @for (opt of statusOptions; track opt.value) {
                        <option [ngValue]="opt.value">{{ opt.label }}</option>
                        }
                    </select>
                </div>
                <div class="column-controls">
                <button class="btn btn-outline-primary btn-sm toggle-btn" (click)="toggleColumnPanel()">
                    {{ (showColumnPanel ? "labels.hideColumnOptions" : "labels.showColumnOptions") | translate }}
                </button>
                @if (showColumnPanel) {
                <div class="column-panel">
                    <div class="column-list">
                        @for (column of columnVisibility; track column.field) {
                        <label class="column-item">
                            <input type="checkbox" [checked]="column.visible"
                                [disabled]="isLockedColumn(column.field)"
                                (change)="toggleColumnVisibility(column.field)" />
                            <span>{{ column.headerName }}</span>
                        </label>
                        }
                    </div>
                </div>
                }
                </div>
            </div>
            <button class="btn btn-primary" (click)="openCreateExtension()">
                {{ "extensions.create" | translate }}
            </button>
        </div>
        <ag-grid-angular style="width: 100%; height: 350px" [rowData]="extensionRows"
            [columnDefs]="extensionColDefs" [defaultColDef]="extensionDefaultColDef"
            [context]="extensionGridContext" [getRowClass]="getExtensionRowClass"
            (gridReady)="onExtensionGridReady($event)" />
    </div>
    }@else if(showTab ==="Comments") {
    <app-contract-comments [contractId]="contractId"></app-contract-comments>
    }

</div>